// extracted by mini-css-extract-plugin
module.exports = {"message":"AnswerSamplesMessage_message__10G82","icon":"AnswerSamplesMessage_icon__32wzd"};